import React, { useEffect, useCallback, useState} from 'react';
import {setSampleTooltip} from 'actions/index.js';
import Sample from 'repos/Sample.js';
import Colors from "components/Colors.js";

import ConditionedComponent from "components/ConditionedComponent.js"
import {connect} from 'react-redux';

const colors = new Colors();
let id = 0;

const SampleInfo = ({
    thumbnail,
    sample,
    sampleId,
    annotations,
    onDragStart,
    onMouseDown,
    onMouseUp,
    position,
    sequencerEngine,
    onClickSample
}) => { 
    let [hovered, setHovered] = useState(undefined);

    const setSampleInfo = (sampleInfo) => {
        sequencerEngine.store.dispatch(setSampleTooltip(sampleInfo));
    };

    useEffect(() => {
        if (!hovered) {
            setSampleInfo(undefined);
            return;
        }
        let c = ++id;
        setTimeout(() =>  {
            if (c === id) {
                let sample = new Sample(hovered);
                sample.load(false)
                    .then(x => {
                        setSampleInfo(sample);
                    });
            }
        }, 100);
    }, [hovered, setSampleInfo]);
    
    let style = {
        borderColor: colors.saturate(colors.getColorForHash(sampleId), 3)
    };

    if (thumbnail && thumbnail !== '') {
        style.backgroundImage = "url(\"" + thumbnail + "\")"; 
    } else {
    }

    return (
        <div
          style={{backgroundColor: colors.saturate(colors.getColorForHash(sampleId), 3)}}
          draggable={true}
          onDragStart={(e) => onDragStart(sampleId)}
          onDragOver={(e) => e.stopPropagation()}
          className='sample-container'>
          <div
            onMouseDown={() => onMouseDown(sampleId)}
            onMouseOver={() => setHovered(sampleId)}
            onMouseLeave={() => setHovered(undefined)}
            onMouseUp={() => onMouseUp(sampleId)}
            onClick={() => onClickSample(sampleId)}
            className={sampleId === sample.ipfsHash ? "sample-from-source selected" : "sample-from-source"}
            style={style}>
            <ConditionedComponent condition={annotations.has(sampleId)}>
              <div className="dot sample-annotation"></div>
            </ConditionedComponent>
          </div>
        </div>
    );
};

export default SampleInfo;
